/**
 * A button offering a change of dictionary, and the note explaining it.
 *
 * There are two of these on the hanzi page and they are the same shape: a
 * button that swaps the dictionary, and a sentence beside it saying what the
 * swap is for. Both are shown and hidden together, because the note is only
 * meaningful while the offer stands. Hiding the button on its own used to leave
 * "Adds 400,000 mostly-name entries" sitting under a dictionary that already
 * had them, and left the block's own spacing behind with it.
 *
 * Every part is optional. A template may offer one of the two, or neither, and
 * an offer with no button in the page is an offer that quietly does nothing
 * rather than one that throws on a template change.
 */
export interface TierOfferProps {
  /** The button, where the template has one. */
  readonly button: HTMLButtonElement | undefined;

  /** The block holding the button and its note, where the template has one. */
  readonly panel: HTMLElement | undefined;
}

/**
 * One of the two offers: load the bigger dictionary, or go back to the smaller.
 */
export class TierOffer {
  readonly #button: HTMLButtonElement | undefined;
  readonly #panel: HTMLElement | undefined;

  constructor(properties: TierOfferProps) {
    this.#button = properties.button;
    this.#panel = properties.panel;
  }

  /** Do this when the offer is taken. */
  onChosen(chosen: () => void): void {
    this.#button?.addEventListener("click", chosen);
  }

  /** Show or hide the offer, note and all. */
  show(isOffered: boolean): void {
    if (this.#button !== undefined) {
      this.#button.hidden = !isOffered;
    }

    if (this.#panel !== undefined) {
      this.#panel.hidden = !isOffered;
    }
  }
}
